define('views/subscriptions/Podio.Views.SubscriptionsList',['require','underscore','lib/backbone/Backbone.PodioView','jst!subscriptions/_list_modal','jst!subscriptions/_list_item'],function(require) {

  var _ = require('underscore');
  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');

  var jstSubscriptionList = require('jst!subscriptions/_list_modal');
  var jstSubscriptionListItem = require('jst!subscriptions/_list_item');

  return ViewPodioBase.extend({

    initialize: function( options ) {
      _.bindAll(this, 'render');
      this._super();
    },

    render: function() {

      this.elm.html(this.getTemplate(jstSubscriptionList, {
        apps: this.options.apps,
        spaces: this.options.spaces,
        jstItem: jstSubscriptionListItem
      }));

    }

  });

});

